import { ChangeDetectorRef, Component, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { ESRI } from '../../../esri-loader-util';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { IMapcoreDynamicLayer, IMapcoreFeatureLayer, IMapcoreMapImageLayer, IMapcoreProps, IQuery } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-layer-detail-ng',
    styleUrls: ['../../sharedStyles/base.scss', './layer-detail.component.scss'],
    templateUrl: './layer-detail.component.html'
})
export class LayerDetailComponent extends BaseComponent implements OnInit {
    get includeGoogleAnalytics() { return false; }

    @Input() uniqueLayerId: string;

    constructor(_vcr: ViewContainerRef,
        private readonly cdr: ChangeDetectorRef,
        private readonly layerService: LayerService,
        private readonly toSqlStringService: ToSqlStringService,
        private readonly filterService: FilterService) {
        super(_vcr);

        this.filterService.applyFilter.subscribe((esriLayer: any) => {
            if (this.esriLayer.uid === esriLayer.uid) {
                this.esriLayer = esriLayer;
                this.setupLayerDetails();
            }
        });
    }

    esriLayer: any;
    recordCount: number | string = null;
    filterRecordCount: number | string = null;
    maximumRecordUpdateDate: Date | string = null;
    simpleQuery = null;
    sqlQuery = null;

    async ngOnInit() {
        this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
        this.setupLayerDetails();
    }

    async setupLayerDetails() {
        this.setupRecordCounts(this.esriLayer);
        if (this.esriLayer.mapcoreProps && this.esriLayer.type === 'map-image') {
            this.simpleQuery = 'None';
            const props = this.esriLayer.mapcoreProps as IMapcoreProps;
            const query = props.query;
            if (query) {
                if (query.operator) {
                    this.simpleQuery = this.filterService.getSummaryQuery(query, props.columns, props.joinColumns, props.childColumns);
                }
            }
            const rootQuery: IQuery = { operator: 'AND', subqueries: [] };
            if (props.parentQuery) {
                rootQuery.subqueries.push(props.parentQuery);
            }
            if (query) {
                rootQuery.subqueries.push(query);
            }
            this.sqlQuery = this.toSqlStringService.getSQLFromQuery(rootQuery, props.tables.sort((a, b) => a.geometryType.localeCompare(b.geometryType))[0], props.columns);
            this.isReady();
        } else {
            this.isReady();
        }
    }

    async setupRecordCounts(layer: IMapcoreFeatureLayer | IMapcoreDynamicLayer | IMapcoreMapImageLayer) {
        const props = layer.mapcoreProps;
        this.filterRecordCount = null;
        this.recordCount = 'Loading...';
        this.maximumRecordUpdateDate = 'Unknown';
        if (props && layer.type === 'map-image') {
            this.filterRecordCount = 'Loading...';
            const rootQuery: IQuery = { operator: 'AND', subqueries: [] };
            if (props.parentQuery) {
                rootQuery.subqueries.push(props.parentQuery);
            }
            if (props.query) {
                rootQuery.subqueries.push(props.query);
            }
            this.maximumRecordUpdateDate = 'Loading';
            this.layerService.getLayerRecordCount(props.parentId, rootQuery).then(data => {
                this.filterRecordCount = data[0].recordCount;
                this.maximumRecordUpdateDate = data[0].maximumRecordUpdateDate;
                if (!this.maximumRecordUpdateDate) {
                    this.maximumRecordUpdateDate = 'Unknown';
                }
                this.cdr.detectChanges();
            }).catch(() => {
                this.filterRecordCount = 'Error';
                this.cdr.detectChanges();
            });
            this.layerService.getLayerRecordCount(props.parentId).then(data => {
                this.recordCount = data[0].recordCount;
                this.cdr.detectChanges();
            }).catch(() => {
                this.recordCount = 'Error';
                this.cdr.detectChanges();
            });
        } else if (props && props.url) {
            this.filterRecordCount = null; // TODO: Allow filtering on feature layer
            const [QueryTask] = await Promise.all([ESRI.QueryTask]);
            const task = new QueryTask({ url: props.url });
            const query = (<IMapcoreFeatureLayer>layer).createQuery();
            query.where = '1=1';
            task.executeForCount(query).then(data => {
                this.recordCount = data;
                this.cdr.detectChanges();
            }).catch(() => {
                this.recordCount = 'Error';
                this.cdr.detectChanges();
            });
        } else if (layer.type === 'feature') {
            this.esriLayer.queryFeatureCount().then(count => {
                this.recordCount = count;
                this.cdr.detectChanges();
            });
        } else {
            this.recordCount = 'Unknown';
        }
    }
}
